import { memo, useMemo } from "react";
import { convertDate, formatDescription } from "../Board";
import { Link } from "react-router-dom";
import Timer from "../../../components/Timer/Timer";
import TaskList from "../components/TaskList";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
export default memo(function NewTasks({ showReporterModal = () => {} }) {
  const tasksHeaders = useMemo(() => {
    return [
      {
        field: "date",
        headerName: "Date create",
        sortable: false,
        type: "string",
        maxWidth: 150,
        flex: 1,
        valueGetter: (params) => convertDate(params.row.asana_created_at),
      },
      {
        field: "name",
        headerName: "Number",
        sortable: false,
        type: "string",
        flex: 1,
        renderCell: (item) => (
          <>
            <Link to={item.row?.permalink_url} target="_blank">
              <span
                dangerouslySetInnerHTML={{
                  __html: item.value,
                }}
              />
            </Link>
          </>
        ),
      },
      {
        field: "notes",
        headerName: "Description",
        sortable: false,
        flex: 1,
        type: "string",
        renderCell: (item) => (
          <span
            dangerouslySetInnerHTML={{
              __html: formatDescription(item.value),
            }}
          />
        ),
      },
      {
        field: "reporter",
        headerName: "Reporter",
        sortable: false,
        maxWidth: 200,
        flex: 1,
        renderCell: (item) => (
          <div>
            <div className="flex">
              <span
                onClick={() => showReporterModal(item.value)}
                style={{ paddingRight: "5px", cursor: "pointer" }}
                title={"Show all tasks"}
              >
                <AccountCircleIcon sx={{ "&:hover": { color: "#1976d2" } }} />
              </span>
              <span>{item.value}</span>
            </div>
            <div>
              <a
                target={"_blank"}
                href={`https://app.asana.com/0/search?sort=last_modified&searched_type=task&completion=incomplete&deleted=no_trashed&locatedIn=inAnyOfTheseProjects&any_projects.ids=1205311495757615&custom_field_1205641416680614.variant=contains&custom_field_1205641416680614.value=${item.value}`}
                rel="noreferrer"
                style={{ color: "#1976d2" }}
              >
                Show open tasks
              </a>
            </div>
          </div>
        ),
      },
      {
        field: "time",
        headerName: "Time",
        sortable: false,
        maxWidth: 180,
        flex: 1,
        renderCell: (item) => (
          <Timer height={20} date_from={item.row?.asana_created_at} />
        ),
      },
    ];
  }, []);

  return (
    <TaskList
      title="New tasks"
      tasksHeaders={tasksHeaders}
      // filter={{ assignee_id: "" }}
      filter={{ status: "new,reopened", assignee_id: "" }}
    />
  );
});
